import axiosInstance from '../axiosInterceptor/axiosInstance'
import eventCollection from '../../utils/helpers/eventHelpers/eventCollection'

const deleteEvent = async (data) => {
  const { eventTypeCode, eventId, orgId } = data
  const url = `v1/orgs/${orgId}/events/${eventCollection(eventTypeCode)}/${eventId}`
  return axiosInstance.delete(url)
}

export default deleteEvent
